import { envName } from "@faire/web--source/common/user-agent/envName";
import { isProduction } from "@faire/web--source/common/user-agent/isProduction";
import { releaseVersion } from "@faire/web--source/common/user-agent/releaseVersion";
export var isLocal = function() {
    var _releaseVersion;
    return !isProduction() && ((_releaseVersion = releaseVersion()) === null || _releaseVersion === void 0 ? void 0 : _releaseVersion.indexOf("static")) === 0 || envName() === "local";
};
